import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-cabinet-unit-heater-coil-options',
    templateUrl: './cabinet-unit-heater-coil-options.component.html',
    styleUrls: ['./cabinet-unit-heater-coil-options.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class CabinetUnitHeaterCoilOptionsComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  coilUnionsSelection!: GuruEntity;
  autoAirVentsSelection!: GuruEntity;
  drainValveSelection!: GuruEntity;
  coilConstructionSelection!: GuruEntity;
  testPressureSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.COIL_OPTIONS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.coilUnionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USUnionsOnCoil');
    this.autoAirVentsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USAutoVents');
    this.drainValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USDrainValve');
    this.coilConstructionSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCoilEndSheet');
    this.testPressureSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCoilTestPressure');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
